import { call, put, takeLatest, all } from 'redux-saga/effects';
import { showToast } from 'app/store/actions/fuse';
import * as Actions from '../../actions';
import apiResourcesService from 'app/services/apiResourcesService';

function* fetchAllApiResources(action) {
	try {
		const response = yield call(() => apiResourcesService.fetchAllApiResources());
		yield put(Actions.fetchAllApiResourcesSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to Retrieve Api Resources ' + error));
		yield put(Actions.fetchAllApiResourcesFailure());
	}
}

function* watchApiResources() {
	yield all([takeLatest(Actions.fetchAllApiResources, fetchAllApiResources)]);
}

export default watchApiResources;
